import LabServiceCollection from "@/collections/LabServiceCollection";
import SampleStatusLogModel from "../../models/lab/SampleStatusLogModel";

/**
 * SampleStatusLog collection
 */
export default class SampleStatusLogCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return SampleStatusLogModel;
  }

  /**
   * default collection configuration.
   */
  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddDesc('created_at');
    return CollectionFilter;
  }

}
